import i18n from '../../../i18n';

export type EmailStatusTag = { label: string; className: string };

const STATUS_CLASS: Record<string, string> = {
  WAITING_CREATOR: 'bg-slate-100 text-slate-500',
  NEED_REPLY: 'bg-amber-50 text-amber-600',
  PROCESSED: 'bg-emerald-50 text-emerald-600',
  HARD_BOUNCE: 'bg-red-50 text-red-500'
};

const STATUS_KEYS = ['WAITING_CREATOR', 'NEED_REPLY', 'PROCESSED', 'HARD_BOUNCE'] as const;

function statusLabel(status: (typeof STATUS_KEYS)[number]) {
  switch (status) {
    case 'WAITING_CREATOR':
      return i18n.t('email.status_WAITING_CREATOR');
    case 'NEED_REPLY':
      return i18n.t('email.status_NEED_REPLY');
    case 'PROCESSED':
      return i18n.t('email.status_PROCESSED');
    case 'HARD_BOUNCE':
      return i18n.t('email.status_HARD_BOUNCE');
  }
}

export function emailStatusTag(status?: string): EmailStatusTag | null {
  if (!status) return null;
  const known = STATUS_KEYS.find((item) => item === status);
  return {
    label: known ? statusLabel(known) : status,
    className: STATUS_CLASS[status] || 'bg-slate-100 text-slate-500'
  };
}
